import * as React from 'react';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';
import './PackageNeverArrivedInfo.scss';

// Style and misc imports

import { any, element } from 'prop-types';
import UserModel from 'src/model/user.model';

class PackageNeverArrivedClaimInfo extends React.Component<IDamageClaimInfoProps, any> {
  constructor(props: IDamageClaimInfoProps) {
    super(props);
  }

  public render() {
    return (
      <div style={{ marginBottom: '10px'}}>
        <h4>{i18n.t('warrantyView.customerInfo')}</h4>

        <div className="form-row row  DamageClaimInfo">
          <div className="form-group col-sm-12 col-md-4 col-lg-3  mb">
            <label
              className="form-control-placeholder"
              htmlFor="customernumber"
            >
              {i18n.t('partClaim.customerNumber')}:
            </label>
            <input
              className={`form-control grey-color`}
              name="customerNumber"
              type="text"
              value={this.props.DamageCustomerNumber}
              readOnly={true}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default PackageNeverArrivedClaimInfo;

interface IDamageClaimInfoProps {
  DamageCustomerNumber: string;
  DamageClaimNumber: string;
  DamageErrorlist: any;
  DamageErrormsgshow: boolean;
}
